import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16.6875 9L2.4375 9",
		stroke: "currentcolor",
		strokeWidth: 1.125,
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.1875 2.25L1.6875 9L9.1875 15.75",
		stroke: "currentcolor",
		strokeWidth: 1.125,
		strokeLinejoin: "round"
	})]
});
export { SvgArrowLeft as ReactComponent };
